import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import IconButton from '../../../../icon-button';

import IconItem from '../../icon-item';
import WirisEditor from '../../../../wiris-editor';

export const Icon = styled(IconItem)`
    ${({ theme }) => css`
        fill: ${theme.colors['text-myzanichelli-blue-main']};

        &:hover {
            fill: ${theme.colors['text-myzanichelli-blue-dark']};
        }

        &[disabled] {
            fill: ${theme.colors['text-grey-700']};
        }
    `}
`;

const EditableBox = ({ content, onClick, onChange, onConfirm, isDisabled }) => {
    return (
        <>
            <WirisEditor content={content} onChange={(value) => onChange(value)} onConfirm={() => onConfirm(content)} />

            <IconButton type="tertiary" size="xsmall" onClick={onClick} disabled={isDisabled}>
                <Icon name="delete" disabled={isDisabled} />
            </IconButton>
        </>
    );
};

EditableBox.propTypes = {
    content: PropTypes.string,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    onConfirm: PropTypes.func,
};

export default EditableBox;
